import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export function useNavigationShortcuts() {
  const navigate = useNavigate();
  const pendingKey = useRef<string | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Skip if in input/textarea/select
      const active = document.activeElement;
      if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.tagName === 'SELECT')) {
        return;
      }
      // Skip if modifier keys are held
      if (e.ctrlKey || e.metaKey || e.altKey) return;

      const key = e.key.toLowerCase();

      if (pendingKey.current === 'g') {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        pendingKey.current = null;

        const routes: Record<string, string> = {
          d: '/',
          p: '/projects',
          t: '/my-tasks',
          n: '/notifications',
          g: '/gantt',
          r: '/reports',
          s: '/settings',
          h: '/help',
        };

        if (routes[key]) {
          e.preventDefault();
          navigate(routes[key]);
        }
        return;
      }

      if (key === 'g') {
        pendingKey.current = 'g';
        timeoutRef.current = setTimeout(() => {
          pendingKey.current = null;
        }, 500);
      }
    };

    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [navigate]);
}
